import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import Header from '../components/header'; 
import Footer from '../components/footer'; 
import RoomGallerySlider from '../components/RoomGallerySlider'; 
import FloatingSocial from '../components/floating_social'; 
import "react-datepicker/dist/react-datepicker.css";
import "../../css/checkout.css";
import { useSearchParams } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Modal } from 'bootstrap';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const RoomsCheckout = () => {

  const [searchParams] = useSearchParams();
  const roomId = searchParams.get("room_id");

useEffect(() => {
  setCheckin(searchParams.get("checkin") || "");
  setCheckout(searchParams.get("checkout") || "");
  setAdults(searchParams.get("adults") || "1");
  setchildrens(searchParams.get("children") || "0");
  setRooms(Number(searchParams.get("rooms") || 1));
}, []);


  const [roomDetails, setRoomDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checkin, setCheckin] = useState("");
  const [checkout, setCheckout] = useState("");
  const [adults, setAdults] = useState("");
   const [childrens, setchildrens] = useState("");
  const [rooms, setRooms] = useState(1);
  const [summary, setSummary] = useState("");
  const [nightcount, setNights] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
});

  const API_BOOKING = `${BASE_URL}getpagedata/booking.php`;

const [selectedOption, setSelectedOption] = useState("full"); // "full" | "partial" | "hotel"

const GST_RATE = 105;      // 5%
const FULL_DISCOUNT = 0.10; // 10%

const baseprice = totalPrice / GST_RATE * 100;
// price before any discount
const roomCharges = totalPrice * nightcount;

// tax
const gstAmount = baseprice * 5/100;

// discount only when FULL payment
const discount = selectedOption === "full" ? roomCharges * FULL_DISCOUNT : 0;

// total (after discount + tax + service)
const finalAmount =
  roomCharges + gstAmount;

// Amount-to-pay-now
let payNow = 0;
let payAtHotel = 0;
let totalroomcharges = 0;
let gstamt = 0;
let getdiscount = 0;
let total =0;
let getloadeprice =0;

  // PAY AT HOTEL
  payNow = 0;
  payAtHotel = finalAmount;

const handleSelectOption = (option) => {
  setSelectedOption(option);
};


  // ✅ ALWAYS CALL HOOKS AT TOP LEVEL
  useEffect(() => {
    if (!roomId) {
      setLoading(false);
      return;
    }

    axios
      .get(`${BASE_URL}getpagedata/fetch_room_details.php?room_id=${roomId}`)
      .then((res) => {
        setRoomDetails(res.data);
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  }, [roomId]);

  // ✅ Show loading state
  if (loading) {
    return <p className="text-center mt-5">Loading room information...</p>;
  }

  // ✅ Handle no room found
  if (!roomDetails || !roomDetails.room) {
    return <p className="text-center mt-5 text-danger">Room not found!</p>;
  }

  // ✅ NOW SAFE TO EXTRACT DATA
  const room = roomDetails.room;
  const amenities = roomDetails.amenities || [];
  const inventory = roomDetails.inventory || 0;
  const price = Number(roomDetails.room.price);
  const partialPay = (price * 0.3).toFixed(2);
  const restpayment = (price - partialPay);

const PRICE_PER_NIGHT = price;
  

if(totalPrice == 0)
{
	getloadeprice = price;
}
else
{
	getloadeprice = totalPrice;
}


const handleSendEnquiry = () => {
  const name = document.getElementById("enquiryName").value;
  const mobile = document.getElementById("enquiryMobile").value;
  const message = document.getElementById("enquiryMessage").value;

  console.log("Enquiry submitted:", { name, mobile, message });

  // send enquiry to backend

  // Close modal
const handleSendEnquiry = () => {
  const modalEl = document.getElementById("enquiryModal");
  const modal = Modal.getInstance(modalEl);
  modal.hide();
};
};

  const updateSummary = () => {
    if (!checkin || !checkout) {
      setSummary("Please select both dates");
      setTotalPrice(0);
      return;
    }

    const start = dayjs(checkin);
    const end = dayjs(checkout);

    const nights = end.diff(start, "day");

    if (nights <= 0) {
      setSummary("Checkout date must be after check-in date");
      setTotalPrice(0);
      return;
    }

    // Calculate cancellation date
    const cancellationDate = end
      .add(2, "day")
      .format("DD MMM YYYY");

    // PRICE CALCULATION
    const nprice = nights * rooms * PRICE_PER_NIGHT;
    setTotalPrice(nprice);
	setNights(nights);

    setSummary(
      `${nights} night${nights > 1 ? "s" : ""} selected • Free cancellation until ${cancellationDate}`
    );

	
  };


 /* ================= FORM ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };


const handleConfirmBooking = async () => {
  try {
    const payload = {
	  roomId: Number(roomId), // ✅ MUST MATCH PHP
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      adults: Number(adults),
      childrens: Number(childrens),
      checkin,
      checkout,
      noof_room: Number(rooms),   // ✅ REQUIRED
      totalPrice: Number(totalPrice), // ✅ MUST MATCH PHP
      summary
    };

    console.log("SENDING TO SERVER:", payload);

    const res = await axios.post(API_BOOKING, payload, {
      headers: { "Content-Type": "application/json" }
    });

    if (res.data.status === "success") {
      alert("Booking confirmed!");
      document.querySelector("#bookNowModal .btn-close")?.click();
    } else {
      alert(res.data.message);
    }
  } catch (err) {
    console.error("AXIOS ERROR:", err.response?.data || err.message);
    alert(err.response?.data?.message || "Server error");
  }
};



  
  return (
    <div>
        <Header />
     
	<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/3.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Our Rooms</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	
	 <div className="container">
		 <br></br>
		<div className="booking-card background-dark">
			<h4 className="mb-4" style={{ color: `var(--primary-color)` }}>Modify Your Dates</h4>
			<div className="row g-4">
				<div className="col-md-2">
					<div>
						<label for="checkin" className="form-label fw-bold">Check-in Date</label>
						<input
							type="date"
							className="form-control"
							value={checkin}
							min={new Date().toISOString().split("T")[0]}  // ✅ today or future only
							onChange={(e) => setCheckin(e.target.value)}
							/>

					</div>
				</div>
				<div className="col-md-2">
					<div>
						<label for="checkout" className="form-label fw-bold">Check-out Date</label>
						 <input
							type="date"
							className="form-control"
							value={checkout}
							min={new Date().toISOString().split("T")[0]}  // ✅ today or future only
							onChange={(e) => setCheckout(e.target.value)}/>
					</div>
				</div>
				<div className="col-md-2">
					<div>
						<label for="guests" className="form-label fw-bold">Adults</label>
						<select className="form-control" id="adults" value={adults}
  						onChange={(e) => setAdults(e.target.value)}>
							<option value="0">0</option>
							<option value="1" selected>1</option>
							<option value="2" >2</option>
							<option value="3">3</option>
							<option value="4">4</option>
							<option value="5">5</option>
						</select>
					</div>
				</div>
				<div className="col-md-2">
					<div>
						<label for="guests" className="form-label fw-bold">Children</label>
						<select className="form-control" id="children" value={childrens}
  						onChange={(e) => setchildrens(e.target.value)}>
							<option value="0">0</option>
							<option value="1">1</option>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
						</select>
					</div>
				</div>
				<div className="col-md-2">
					<div>
						<label for="rooms" className="form-label fw-bold">Rooms</label>
					<select
						className="form-control"
						value={rooms}
						onChange={(e) => setRooms(Number(e.target.value))}>
						<option value="1" selected>1 Room</option>
						<option value="2">2 Rooms</option>
						<option value="3">3 Rooms</option>
					</select>
					</div>
				</div>
				<div className="col-md-2 d-flex align-items-end">
					 <button className="btn-update w-100" onClick={updateSummary}>
						<i className="fa fa-sync-alt me-2"></i>Update
					</button>
				</div>
			</div>
			<div className="row mt-3">
				<div className="col-12">
					<p className="text-muted mb-0"><i className="fa fa-info-circle me-2"></i>&nbsp;  {summary}</p>
				</div>
			</div>
		</div>

	 
		<div className="row">
 
			<div className="col-lg-8">
				<div className="hotel-card">
					 <RoomGallerySlider />				

					 
					<div className="hotel-info-content">
						<div className="d-flex justify-content-between align-items-start mb-3">
							<div>
								<h2 style={{ color: `var(--primary-color)` }}>{roomDetails.room.room_name}</h2>
								{/* <p className="text-muted mb-2"><i className="fas fa-map-marker-alt me-2"></i>123 Marine Drive, Mumbai,
									Maharashtra 400020</p> */}
							</div>
							<div className="hotel-rating">5 ★</div>
						</div>

						<p className="mb-4"
						dangerouslySetInnerHTML={{
							__html: roomDetails?.room?.description || ""
						}}></p>					 

						<h5 className="mb-3" style={{ color: `var(--primary-color)` }}>Amenities</h5>
						<div className="mb-4 amenity-wrapper">
							
						{amenities.length > 0 ? (
							amenities.map((item) => (
							<span key={item.id} className="amenity-badge">
								<img 
								src={`${item.image}`} 
								alt={item.name} 
								className="amenity-icon"
								/>
								{item.name}
							</span>
							))
						) : (
							<p className="text-muted">No amenities listed for this room.</p>
						)}
						</div>

						<div className="mt-4">
							<h5 style={{ color: `var(--primary-color)` }}>Room Details</h5>
							<div className="row mt-3">
								<div className="col-md-4">
									<p><i className="fa fa-check-circle text-success me-2"></i>&nbsp; No Booking Fees</p>
									<p><i className="fa fa-check-circle text-success me-2"></i>&nbsp; Best rate guarantee</p>
								</div>
								<div className="col-md-4">
									<p><i className="fa fa-check-circle text-success me-2"></i>&nbsp; Reservation 24/7</p>
									<p><i className="fa fa-check-circle text-success me-2"></i>&nbsp; High Speed WIFI</p>
								</div>
								<div className="col-md-4">
									<p><i className="fa fa-check-circle text-success me-2"></i>&nbsp; Dining</p>
									<p><i className="fa fa-check-circle text-success me-2"></i>&nbsp; No Smoking</p>
								</div>
							</div>
							<p className="mt-3"><i className="fa fa-check-circle text-success me-2"></i>&nbsp; Our Deluxe Room delivers comfort and style, featuring air-conditioning, a flat-screen TV, hot and cold water, and 24/7 room service. Thoughtfully designed for leisure guests and families, it offers a convenient and a calm stay at one of the best hotels in Rourkela.</p>
						</div>
					</div>
				</div>
			</div>

		 
			<div className="col-lg-4">
				<div className="booking-card">
					<h5 className="mb-4" >Payment Information</h5>

					 
					<div>
						<div className="d-flex justify-content-between align-items-center">
							<div>
								<h6 className="mb-1">Pay at Hotel</h6>
								<p className="text-muted mb-0">No payment now</p>
							</div>
							<div className="text-end">
								<h5 className="mb-0" ><span className="rupee-symbol">₹</span>{getloadeprice.toFixed(0)}</h5>
								 
							</div>
						</div>
					</div>

					 
					<div className="price-breakdown mt-4">
						<h5 className="mb-3" >Price Breakdown</h5>

						<div className="d-flex justify-content-between mb-2">
							<span>Room Charges ({nightcount.toLocaleString()} nights)</span>
							<span><span className="rupee-symbol">₹</span>{baseprice.toFixed(0)}</span>
						</div>

						<div className="d-flex justify-content-between mb-2">
							<span>Taxes & Fees (5% GST)</span>
							<span><span className="rupee-symbol">₹</span>{gstAmount.toFixed(0)} </span>
						</div>

					 
						<hr/>

						

						<div className="d-flex justify-content-between">
							<span> Pay at Hotel</span>
							<span id="payHotelAmount" className="fw-bold"><span className="rupee-symbol">₹</span>{totalPrice.toFixed(0)}</span>
						</div>
					</div>

					 
					<div className="final-price">
						<h4 className="mb-2">Final Price</h4>
						<h3 id="finalPrice"><span className="rupee-symbol">₹</span>{totalPrice.toFixed(0)}</h3>
						<p className="mb-0">Including all taxes and charges</p>
						<p className="mb-0"><small><i className="fas fa-shield-alt me-1"></i>Secure booking with free cancellation</small>
						</p>
					</div>

					{totalPrice !== 0 && (
					<button
						className="btn-book mt-4"
						id="bookNowBtn"
						data-bs-toggle="modal"
						data-bs-target="#bookNowModal"
					>
						<i className="fa fa-calendar me-2"></i>&nbsp; Book Now
					</button>
					)}
							  


					<p className="text-center text-muted mt-3"><small>You won't be charged yet. Free cancellation available.</small>
					</p>

					<div className="mt-3 text-center payment-icons">
						<span className="text-muted me-2">We accept:</span>
						<img src="https://img.icons8.com/color/48/000000/rupay.png" alt="RuPay" title="RuPay"/>
						<img src="https://img.icons8.com/color/48/000000/visa.png" alt="Visa" title="Visa"/>
						<img src="https://img.icons8.com/color/48/000000/mastercard.png" alt="Mastercard" title="Mastercard"/>
						<img src="https://img.icons8.com/color/48/000000/paytm.png" alt="Paytm" title="Paytm"/>
						<img src="https://img.icons8.com/color/48/000000/google-pay.png" alt="Google Pay" title="Google Pay"/>
					</div>
				</div>
			</div>
		</div>
		<div className="row mt-4">
			<div className="col-12">
				<div className="booking-card">
					<h4 className="mb-3" >Important Information</h4>
					<div className="row">
						<div className="col-md-12 mb-3">
							<p className="mb-4"
						dangerouslySetInnerHTML={{
							__html: roomDetails?.room?.policy || ""
						}}></p>		
							 
						</div>
					 
					</div>
				</div>
			</div>
		</div>
	</div>

	 
	
	<div className="modal fade" id="bookNowModal" tabIndex="-1">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">

      <div className="modal-header">
        <h5 className="modal-title">Confirm Your Booking</h5>
		<button type="button" className="btn-close"  data-bs-dismiss="modal">X</button>
        
      </div>

      <div className="modal-body">
        <form>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Full Name *</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Email Address *</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Phone Number *</label>
              <input
                type="tel"
                className="form-control"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Guests</label><br />
			  <input type="hidden" name="adults" value={adults} />
			   <input type="hidden" name="childrens" value={childrens} />
              {adults} Adults + {childrens} Children
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Check-in</label><br />
			   <input type="hidden" name="checkin" value={checkin} />
              {checkin}
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Check-out</label><br />
			   <input type="hidden" name="checkout" value={checkout} />
              {checkout}
            </div>
          </div>
        </form>

        <hr />
        <p className="text-muted">
          <i className="fa fa-info-circle me-2"></i>{summary}
		  <input type="hidden" name="summary" value={summary} />
		  <input type="hidden" name="noof_room" value={rooms} />
		  <input type="hidden" name="total_price" value={totalPrice} />
		  <input type="hidden" name="roomId" value={roomId} />
        </p>
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button className="btn btn-success" onClick={handleConfirmBooking}>
          Confirm Booking
        </button>
      </div>

    </div>
  </div>
</div>



	<Footer />
	<FloatingSocial />
	</div>
	 
  )
}

export default RoomsCheckout;